import { render, staticRenderFns } from "./OpportunitiesList.vue?vue&type=template&id=4335f112&"
import script from "./OpportunitiesList.vue?vue&type=script&lang=js&"
export * from "./OpportunitiesList.vue?vue&type=script&lang=js&"
import style0 from "./OpportunitiesList.vue?vue&type=style&index=0&id=4335f112&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports